import Vue from "Vue";
import BasePage from "Shared/basePage";
import productPageInstance from "ProductPage/productPageInstance"; 

export default class ProductPage extends BasePage {
	constructor(options) {
		super();

		this._initializeVueInstance(options);
	}

	_initializeVueInstance(options) {
		this._productPageInstance = new Vue({
			...productPageInstance(options),
			store: this.store
		});
	}
}